import Hammer from 'hammerjs'

const gestures = ['tap', 'pan', 'pinch', 'press', 'rotate', 'swipe']
const directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all']

export default {
  bind(el, binding) {
    if (!el.hammer) el.hammer = new Hammer.Manager(el)
    const mc = el.hammer
    if (!binding.value && mc) return mc.handler = null
    const event = binding.arg
    if (!event) console.warn('[vue-hammer] event type argument is required.')
    if (!gestures.includes(event)) console.warn('[vue-hammer] event type argument is invalid.')

    let recognizer = mc.get(event)
    if (!recognizer) {
      recognizer = new Hammer[event.capitalize()]()
      recognizer.recognizeWith(mc.recognizers)
      mc.add(recognizer)
    }

    const direction = binding.modifiers.keys().find(k => directions.includes(k))
    if (direction) recognizer.set({ direction: Hammer['DIRECTION_' + direction.toUpperCase()] })
  },
  inserted(el, binding) {
    const mc = el.hammer
    if (!binding.value && mc) return mc.handler = null
    const event = binding.arg
    if (mc.handler) mc.off(event, mc.handler)
    if (typeof binding.value !== 'function') {
      mc.handler = null
      // console.warn('[vue-hammer] invalid handler function for v-touch: ' + event)
    } else {
      mc.on(event, (mc.handler = binding.value))
    }
  },
  update(el, binding) {
    const mc = el.hammer
    if (!binding.value && mc) return mc.handler = null
    const event = binding.arg
    if (mc.handler) mc.off(event, mc.handler)
    if (typeof binding.value !== 'function') {
      mc.handler = null
      // console.warn('[vue-hammer] invalid handler function for v-touch: ' + event)
    } else {
      mc.on(event, (mc.handler = binding.value))
    }
  },
  unbind(el, binding) {
    const mc = el.hammer
    const event = binding.arg
    if (mc.handler) mc.off(event, mc.handler)
    if (!Object.keys(mc.handlers).length) {
      el.hammer.destroy()
      el.hammer = null
    }
  },
}
